import * as React from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';

// Types
import { IUserNetwork } from '../../store/MeStore';
import { INetwork } from '../../store/NetworkStore';

export type IViewName = 'SELECTOR' | 'JOIN' | 'CREATE';
export type INavigate = (viewName: IViewName) => void;

// Components
import Dialog from '../../components/Dialog';

import NetworksDialogSelector from './NetworksDialogSelector';
import NetworksDialogJoin from './NetworksDialogJoin';
import NetworksDialogCreate from './NetworksDialogCreate';

// Style
import './NetworksDialog.css';

// Component
interface IProps {
  network?: INetwork | null;
  networks: IUserNetwork[];
  state: { open: boolean };
  onClose: () => void;
  onExited?: () => void;
}

class NetworksDialog extends React.Component<IProps> {
  @observable viewName: IViewName = 'SELECTOR';

  navigate = (viewName: IViewName) => {
    this.viewName = viewName;
  };

  handleExited = () => {
    this.viewName = 'SELECTOR';
  };

  renderView(view: IViewName) {
    switch (view) {
      case 'SELECTOR':
        return (
          <NetworksDialogSelector
            network={this.props.network}
            networks={this.props.networks}
            navigate={this.navigate}
            closeDialog={this.props.onClose}
          />
        );
      case 'JOIN':
        return (
          <NetworksDialogJoin
            navigate={this.navigate}
            closeDialog={this.props.onClose}
          />
        );
      case 'CREATE':
        return (
          <NetworksDialogCreate
            navigate={this.navigate}
            closeDialog={this.props.onClose}
          />
        );
      default:
        return null;
    }
  }

  render() {
    return (
      <Dialog
        open={this.props.state.open}
        onClose={this.props.onClose}
        onExited={this.handleExited}
        classes={{ paper: 'App__NetworksDialog__Paper' }}
      >
        {this.renderView(this.viewName)}
      </Dialog>
    );
  }
}

export default observer(NetworksDialog);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/App/NetworksDialog.tsx